export default __webpack_public_path__ + "static/media/danae.a58e0b36.jpg";